import type { PayeeKind, PayoutStatus, PayoutStatusKind } from './payoutShared';

/** `Doctor` / `Referral` chip — payee kind as an attribute, not a page. */
export function PayeeTypeBadge({ payeeType }: { payeeType?: PayeeKind }) {
  const referral = payeeType === 'REFERRAL';
  return (
    <span
      className={`inline-flex px-2 py-0.5 rounded-full text-[0.6875rem] font-medium ${
        referral ? 'bg-warning/10 text-warning' : 'bg-primary/10 text-primary'
      }`}
    >
      {referral ? 'Referral' : 'Doctor'}
    </span>
  );
}

// Tone per settlement status: amber = in progress / not posted, teal = posted
// and payable, blue = partly settled, green = done. Mirrors the Pending/Posted/
// Settled legend in the Outstanding ledger's share breakdown.
const PAYOUT_STATUS_META: Record<PayoutStatusKind, string> = {
  PENDING: 'bg-warning/10 text-warning',
  POSTED: 'bg-primary/10 text-primary',
  PARTIAL: 'bg-sky-500/10 text-sky-500',
  SETTLED: 'bg-success/10 text-success',
};

/** Settlement-status chip for one payee row on the Outstanding ledger. */
export function PayoutStatusBadge({ status }: { status: PayoutStatus }) {
  return (
    <span
      className={`inline-flex whitespace-nowrap rounded-full px-2 py-0.5 text-[0.6875rem] font-medium ${
        PAYOUT_STATUS_META[status.kind]
      }`}
      title={status.hint}
    >
      {status.label}
    </span>
  );
}

export function SourceBadge({ source }: { source?: string }) {
  const isConsultation = source === 'CONSULTATION';
  const isAdmission = source === 'ADMISSION';
  return (
    <span
      className={`inline-flex px-2 py-0.5 rounded-full text-[0.6875rem] font-medium ${
        isConsultation
          ? 'bg-primary/10 text-primary'
          : isAdmission
            ? 'bg-secondary/10 text-secondary'
            : 'bg-success/10 text-success'
      }`}
    >
      {isConsultation ? 'Consultation' : isAdmission ? 'IPD admission' : 'Diagnostic'}
    </span>
  );
}
